import styles from './SliderCard.module.scss';
import React from 'react';
import classNames from 'classnames';
import {
  Button,
  Card,
  CardAction,
  CardBody,
  FontAwesomeProIcon,
  Heading,
  Image,
  getHeadingTag,
} from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';

const SliderCard = ({
  title,
  icon,
  headingLevel,
  action,
  type,
  className,
  as = 'div',
  inSlider = false,
  onClick,
  ...props
}) => (
  <Card
    as={as}
    className={classNames(
      styles.container,
      styles[type],
      { [styles.inSlider]: inSlider },
      className,
    )}
    hasAction={!!action?.url}
    target={action?.target}
    theme={type === 'textSlidingCard' ? 'contrast' : 'default'}
    to={action?.url}
    {...props}
  >
    <CardBody>
      {icon?.src && (
        <Image
          alt={icon?.title || title}
          className={styles.iconSlidingCardImageIcon}
          role="presentation"
          src={icon?.src}
          srcSet={icon?.srcSet}
        />
      )}
      {icon && !icon?.src && (
        <FontAwesomeProIcon
          className={styles.iconSlidingCardImageIcon}
          icon={icon}
        />
      )}
      <Heading
        as={getHeadingTag(headingLevel)}
        className={styles[`${type}Title`]}
        noSpacing
        size="h6"
      >
        {title}
      </Heading>
    </CardBody>
    {action && (
      <CardAction>
        <Button aria-hidden onClick={onClick} shape="bubble" tabIndex={-1}>
          <FontAwesomeProIcon icon="chevron-right" role="presentation" />
        </Button>
      </CardAction>
    )}
  </Card>
);

SliderCard.propTypes = {
  action: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.string,
  }),
  as: PropTypes.elementType,
  className: PropTypes.string,
  headingLevel: PropTypes.number,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  inSlider: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
  type: PropTypes.oneOf(['textSlidingCard', 'iconSlidingCard']).isRequired,
};

export default SliderCard;
